import { gateway } from "../../../gateway";

export const getBusinessOwner = async () => {
    try {
        const res = await gateway.get("/companies/people/self", {
            headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` }
        })
        return res?.data || res?.data?.data;
    } catch (error) {
        console.error(error);
        return error;
    }
}